import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/fla/")({
  component: () => <Navigate to="/fla/batches" />,
});
